module.exports = __webpack_public_path__ + "img/icon1.65aa75bb.png";